import { ModuleLayout, NavigationItem } from '@/components/ModuleLayout'
import { BookUser, BarChart3, Users, UserMinus } from 'lucide-react'
import { SociosChatWidget } from '@/components/socios/SociosChatWidget'
import { usePermissions } from '@/hooks/usePermissions'

export function SociosLayout({ children }: { children: React.ReactNode }) {
  const { can } = usePermissions()
  // Chatbot y reportes usan el recurso 'reports' (no alcanza con poder
  // consultar socios): los bibliotecarios no los ven.
  const canUseReports = can('reports', 'read')

  const navigation: NavigationItem[] = [
    {
      name: 'Socios',
      href: '/socios',
      icon: BookUser,
    },
    ...(canUseReports
      ? [
          {
            name: 'Reportes',
            href: '/socios/reports',
            icon: BarChart3,
          },
        ]
      : []),
    ...(can('library_bajas', 'read')
      ? [
          {
            name: 'Bajas',
            href: '/socios/bajas',
            icon: UserMinus,
          },
        ]
      : []),
  ]

  return (
    <ModuleLayout
      moduleName="Socios"
      moduleIcon={Users}
      moduleColor="from-blue-500 to-blue-600"
      navigation={navigation}
    >
      {children}
      {/* AI assistant — only rendered inside the socios module */}
      {canUseReports && <SociosChatWidget />}
    </ModuleLayout>
  )
}
